import React from 'react';
import { OnboardingHeader } from 'components/onboarding/components/OnboardingHeader';
import './style.scss';
import { OtpHeader } from 'containers/OTP/OtpHeader';
import { QRLinkingHeader } from 'containers/QRLinking/QRLinkingHeader';

//type: login, register, forgotten, OTP
export const OnboardingLayout = ({
  children,
  type = 'login',
  styles = {},
  layoutStyles = {},
}) => {
  return (
    <article className="OnboardingLayout" style={layoutStyles}>
      <div className="OnboardingLayout__Header">
        {type === 'OTP' && <OtpHeader />}
        {type === 'QRLinking' && <QRLinkingHeader />}
        {type !== 'OTP' && type !== 'QRLinking' && (
          <OnboardingHeader type={type} />
        )}
      </div>
      <div className="OnboardingLayout__Overlay" style={styles}>
        {children}
      </div>
    </article>
  );
};
